import React from "react";
import { IonList, IonItem, IonLabel, IonText } from "@ionic/react";
import { WoDocument } from "../models/workorders/Documents";

interface DocumentListDisplayProps {
  documents: WoDocument[];
  onDocumentClick: (doc: WoDocument) => void;
  translations: any;
  translatedMessages: any;
  showLoading: boolean;
  errorData: string;
}

const DocumentListDisplay: React.FC<DocumentListDisplayProps> = ({
  documents,
  onDocumentClick,
  translations,
  translatedMessages,
  showLoading,
  errorData,
}) => {
  if (documents && documents.length > 0) {
    return (
      <IonList>
        {documents.map((doc) => {
          let lastModified = doc.LastModified.endsWith("Z")
            ? new Date(doc.LastModified)
            : new Date(doc.LastModified + "Z");
          return (
            <IonItem key={doc.DmsDocId} onClick={() => onDocumentClick(doc)}>
              <IonLabel>
                <h2>{doc.Description}</h2>
                <p>
                  {translations["lbl_ememployeedocuments_lastmodifiedby"] ||
                    "Last Modified By"}{" "}
                  {doc.LastModifiedBy} on {lastModified.toLocaleString()}
                </p>
              </IonLabel>
            </IonItem>
          );
        })}
      </IonList>
    );
  }
  return (
    <IonText
      hidden={showLoading}
      color={errorData ? "danger" : "default"}
      style={{ padding: "16px", display: "inline-block" }}
    >
      {errorData
        ? translatedMessages["ErrDocRetrieving"]?.MessageText ||
          "Error retrieving documents"
        : translatedMessages["NoResultsFound"]?.MessageText ||
          "No results found."}
    </IonText>
  );
};

export default DocumentListDisplay;